import React, {Component} from 'react'
import {connect} from 'react-redux'
import {setAuthedUser} from '../actions/authedUser'
import {Link} from 'react-router-dom'


//navbar component contains all links and is rendered in app.js
class Navbar extends Component {
  render() {
    return (
			<header>
				<div>
					<h1><Link to="/">Would You Rather?</Link></h1>
		      <nav>
		        <Link to="/add">New Question</Link>
		        <Link to="/leaderboard">Leaderboard</Link>
		        {this.props.loggedIn && (
	            <Link to="/" onClick={() => this.props.dispatch(setAuthedUser(null))}>Logout</Link>
		        )}
		      </nav>
				</div>
			</header>
    )
  }
}

export default connect()(Navbar)
